import React from 'react';
import { Button } from '../components/ui/button';
import { Microscope, Users, Building2, Mail } from 'lucide-react';
import { IMAGES, CONTACT } from '../utils/constants';

const RDSection = () => {
  return (
    <section id="rd-collaboration" className="rd-section section-padding bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="section-header text-center mb-16">
          <h2 className="section-title">R&D and Collaboration</h2>
          <div className="title-underline" />
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="rd-image-wrapper">
            <img src={IMAGES.rd} alt="R&D Collaboration" className="rd-image" />
          </div>
          
          <div className="rd-content">
            <p className="rd-description mb-8">
              We actively collaborate with research institutions, OEMs and system integrators, and energy and mobility innovators. Our approach emphasizes co-development, validation, and scale-up.
            </p>
            
            <div className="rd-partners space-y-6">
              <div className="partner-item">
                <div className="partner-icon-wrapper">
                  <Microscope className="w-8 h-8" />
                </div>
                <div>
                  <h4 className="partner-title">Research Institutions</h4>
                  <p className="partner-description">Collaborating with leading academic and research organizations for material science advancement</p>
                </div>
              </div>

              <div className="partner-item">
                <div className="partner-icon-wrapper">
                  <Building2 className="w-8 h-8" />
                </div>
                <div>
                  <h4 className="partner-title">OEMs & System Integrators</h4>
                  <p className="partner-description">Partnering with manufacturers for seamless integration into production systems</p>
                </div>
              </div>

              <div className="partner-item">
                <div className="partner-icon-wrapper">
                  <Users className="w-8 h-8" />
                </div>
                <div>
                  <h4 className="partner-title">Energy & Mobility Innovators</h4>
                  <p className="partner-description">Working with industry pioneers to develop next-generation solutions</p>
                </div>
              </div>
            </div>

            <Button 
              size="lg" 
              className="mt-8 cta-primary" 
              onClick={() => window.location.href = `mailto:${CONTACT.founderEmail}`}
            >
              Partner With Us <Mail className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RDSection;
